import {useCallback, useMemo} from 'react'
import {Button} from '@primer/react'
import type {SelectPanelItemInput as ItemInput} from '@primer/react'
import {TriangleDownIcon} from '@primer/octicons-react'
import {LabelPicker, type LabelPickerLabel} from '@github-ui/item-picker-label-tsq'

interface DeferredFilterLabelsProps {
  owner: string
  repo: string
  selectedLabels: ItemInput[]
  labelsText: string
  onSelectionChange: (selected: ItemInput[]) => void
}

function DeferredFilterLabels({owner, repo, selectedLabels, labelsText, onSelectionChange}: DeferredFilterLabelsProps) {
  const initialLabels: LabelPickerLabel[] = useMemo(() => {
    return selectedLabels.map(item => ({
      id: String(item.id ?? ''),
      name: item.text ?? '',
      nameHTML: item.text ?? '',
      color: '',
      description: undefined,
      url: '',
    }))
  }, [selectedLabels])

  const handleSelectionChange = useCallback(
    (labels: LabelPickerLabel[]) => {
      onSelectionChange(labels.map(label => ({id: label.id, text: label.name})))
    },
    [onSelectionChange],
  )

  return (
    <LabelPicker
      owner={owner}
      repo={repo}
      labels={initialLabels}
      canCreateLabel={false}
      showColors={false}
      showEditLabelsButton={false}
      selectionVariant="multiple"
      onSelectionChange={handleSelectionChange}
      title="Select Labels"
      anchorElement={(anchorProps, ref) => (
        <Button ref={ref} trailingAction={TriangleDownIcon} {...anchorProps} aria-haspopup="dialog">
          <span className="color-fg-muted">Labels: </span>
          <span id="select-labels">{labelsText}</span>
        </Button>
      )}
    />
  )
}

export default DeferredFilterLabels
